import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { FREE, STARTER } from 'self-service-api/constants/ProductLevels';
import styled from 'styled-components';
import SuiteProductLevelIdentifiersMap from '../../../constants/merchCards/SuiteProductLevelIdentifiersMap';
import { SUITE_FEATURE_TABLE_HEADER } from '../../../constants/tracking/Locations';
import { hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import { ownsCrmSuiteProductLevel } from '../../../selectors/ProductInventorySelectors';
import SuiteFeatureTableBadge from '../../common/SuiteFeatureTableBadge';
import CodeSplitEnvWrapper from '../../common/env/CodeSplitEnvWrapper';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import SuiteTileCTAsContainer from '../../merch-card/SuiteTileCTAsContainer';
import { CrmSuitePrice } from '../../merch-card/price-display/CrmSuitePrice';
import FeatureTableFreePriceDisplay from '../FeatureTableFreePriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TableHeaderCell = styled.th.withConfig({
  displayName: "SuiteFeatureTableHeaderCell__TableHeaderCell",
  componentId: "zsh2fg-0"
})(["text-align:center;font-weight:normal;position:relative;width:", ";padding:16px 0;"], ({
  columns
}) => columns < 3 ? `calc(50%/${columns})` : `calc(70%/${columns})`);
const badgeStyle = {
  top: '16px',
  left: 0,
  right: 0,
  margin: '0 auto',
  width: 'fit-content'
};
const ctaStyles = {
  width: '154px',
  padding: '11px'
};
const SuiteFeatureTableHeaderCell = ({
  productLevel,
  columns,
  isFreeToStarter,
  location
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isFree = productLevel === FREE;
  const contentProps = {
    productLevel,
    concise: true
  };
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel
  }));
  let isHighlightedCell = STARTER === productLevel;
  if (!isFreeToStarter) {
    isHighlightedCell = isCurrentPlanLevel;
  }
  return /*#__PURE__*/_jsxs(TableHeaderCell, {
    columns: columns,
    children: [isHighlightedCell && /*#__PURE__*/_jsx(SuiteFeatureTableBadge, {
      use: isFreeToStarter ? 'new' : 'koala',
      translationKey: isFreeToStarter ? 'recommended' : 'currentPlan',
      badgeStyle: badgeStyle
    }), /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `products.crm.${productLevel}`
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-y-1",
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [19],
        widths: [190],
        className: "flex-column m-y-2",
        Content: isFree ? FeatureTableFreePriceDisplay : CrmSuitePrice,
        contentProps: isFree ? {} : contentProps
      })
    }), isFree ? /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
      authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/upgrade-page/CurrentPlanButton`),
      publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/common/SignupButton`),
      authedComponentProps: {
        ctaStyles: Object.assign({}, ctaStyles, {
          visibility: `${isCurrentPlanLevel ? 'visible' : 'hidden'}`
        })
      },
      publicComponentProps: {
        style: ctaStyles,
        sourceId: SUITE_FEATURE_TABLE_HEADER,
        productLine: 'crm',
        use: 'primary'
      }
    }) : /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !hasPricingAndPurchasingSucceeded,
      heights: [40],
      children: /*#__PURE__*/_jsx(SuiteTileCTAsContainer, {
        productLevel: productLevel,
        trackingSource: SUITE_FEATURE_TABLE_HEADER,
        ctaStyles: ctaStyles,
        returnFirstCTAOnly: true,
        isFreeToStarter: isFreeToStarter,
        location: location,
        hubsSignupProductOverride: SuiteProductLevelIdentifiersMap[productLevel].split('-').join('').toLowerCase()
      })
    })]
  });
};
export default SuiteFeatureTableHeaderCell;